import { useCallback, useRef } from 'react';

export const useSensorPoseEditSession = (
  pushSensorPoseHistory: (sensorId: string) => void,
) => {
  const sessionRef = useRef<string | null>(null);

  const beginSensorPoseEdit = useCallback((sensorId: string, fieldKey: string) => {
    const sessionKey = `${sensorId}:${fieldKey}`;
    if (sessionRef.current === sessionKey) {
      return;
    }
    pushSensorPoseHistory(sensorId);
    sessionRef.current = sessionKey;
  }, [pushSensorPoseHistory]);

  const finishSensorPoseEdit = useCallback(() => {
    sessionRef.current = null;
  }, []);

  return { beginSensorPoseEdit, finishSensorPoseEdit };
};
